import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

import LoadingScreen from './components/LoadingScreen';
const Home = lazy(() => import("./components/Home"));

function App() {
  return (
    <Suspense fallback={LoadingScreen}>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Suspense>
  );
}

export default App;
